module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/6@2x_8a586581796ac550a2e00a2ff560b8fb.png";